import { NavigationItem } from '../types/navigation';
import { colors } from '../styles/theme';

export const services: NavigationItem[] = [
  {
    name: 'Canva Pro',
    path: '/services/canva-pro',
    color: colors.secondary,
    iconName: 'Palette'
  },
  {
    name: 'Offre IA',
    path: '/services/offreia',
    color: colors.accent1,
    iconName: 'Bot'
  },
  {
    name: 'Codex / Claude Code',
    path: '/services/codex-claude-code',
    color: colors.primary,
    iconName: 'Terminal'
  },
  {
    name: 'Hébergement Web',
    path: '/services/hebergement',
    color: colors.tertiary,
    iconName: 'Globe'
  },
  {
    name: 'Serveur privé virtuel',
    path: '/services/vps',
    color: colors.accent2,
    iconName: 'Code'
  },
  {
    name: 'Office 365',
    path: '/services/logiciels',
    color: colors.accent3,
    iconName: 'Laptop'
  },
  {
    name: 'Messagerie',
    path: '/services/mail',
    color: colors.primary,
    iconName: 'Mails'
  }
];
